import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box, Stack } from '@mui/material';
import React from 'react';
import DraftDocumentListFilters from '../../../components/filters/DraftDocumentListFilters';
import DraftsDebitNoteTable from '../components/DraftsDebitNoteTable';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';

const filters = [
  {
    type: 'search',
    options: [
      { key: 'document_number', placeholder: 'Debit Note Number' },
      { key: 'billed_to_name', placeholder: 'Buyer Name' },
      { key: 'billed_to_phone', placeholder: 'Buyer Phone' },
      { key: 'billed_to_tin', placeholder: 'Buyer TIN' },
      { key: 'billed_to_registration_number', placeholder: 'Buyer Registration Number' },
    ],
  },
];

function DraftDebitNoteListPage() {
  useDocumentTitle('Draft Invoice List');
  const {
    selectedFilter,
    currentQuery,
    searchTerm,
    handleDateRangeChange,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useDocumentFilters({
    defaultQuery: { document_type: '03', status: new Set(['draft']) },
  });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box mb={2}>
        <DraftDocumentListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchKeyPress={handleSearchKeyPress}
          onSearchChange={handleSearchChange}
          onDateRangeChange={handleDateRangeChange}
        />
      </Box>
      <DraftsDebitNoteTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default DraftDebitNoteListPage;
